var _path, _path2, _g, _g2, _path3, _path4, _path5, _g3, _g4, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDetailed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 122,
    viewBox: "0 0 299 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M298.89 120H-0.89C-0.95 120 -1 119.95 -1 119.89V4C-1 1.79 0.79 0 3 0H294.89C297.16 0 299 1.84 299 4.11V119.89C299 119.95 298.95 120 298.89 120Z",
    fill: "url(#paint0_linear_223_28185)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M178.44 84.7202C178.44 81.4102 181.13 78.7202 184.44 78.7202C187.75 78.7202 190.44 81.4102 190.44 84.7202C190.44 88.0302 187.75 90.7202 184.44 90.7202C181.13 90.7202 178.44 88.0302 178.44 84.7202ZM184.45 86.5002C183.34 86.5002 182.29 86.3402 181.36 86.0502C181.07 85.9602 180.79 86.2102 180.91 86.4902C181.49 87.8802 182.86 88.8502 184.45 88.8502C186.04 88.8502 187.41 87.8802 187.99 86.4902C188.11 86.2102 187.83 85.9602 187.54 86.0502C186.61 86.3302 185.56 86.5002 184.45 86.5002ZM182.57 81.7202C182.16 81.7202 181.82 82.3902 181.82 83.2202C181.82 84.0502 182.16 84.7202 182.57 84.7202C182.98 84.7202 183.32 84.0502 183.32 83.2202C183.32 82.3902 182.98 81.7202 182.57 81.7202ZM186.32 84.7202C186.73 84.7202 187.07 84.0502 187.07 83.2202C187.07 82.3902 186.73 81.7202 186.32 81.7202C185.91 81.7202 185.57 82.3902 185.57 83.2202C185.57 84.0502 185.91 84.7202 186.32 84.7202Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.94 84.7798C262.94 81.4698 265.63 78.7798 268.94 78.7798C272.25 78.7798 274.94 81.4698 274.94 84.7798C274.94 88.0898 272.25 90.7798 268.94 90.7798C265.63 90.7798 262.94 88.0898 262.94 84.7798ZM271.09 88.0298C271.23 88.1898 271.46 88.1998 271.62 88.0698C271.78 87.9298 271.79 87.6998 271.66 87.5398C271.14 86.9398 270.23 86.2898 268.94 86.2898C267.65 86.2898 266.74 86.9398 266.22 87.5398C266.08 87.6998 266.1 87.9298 266.26 88.0698C266.42 88.2098 266.65 88.1898 266.79 88.0298C267.21 87.5398 267.93 87.0298 268.94 87.0298C269.95 87.0298 270.65 87.5398 271.09 88.0298ZM267.07 82.9098C266.66 82.9098 266.32 83.2498 266.32 83.6598C266.32 84.0698 266.66 84.4098 267.07 84.4098C267.48 84.4098 267.82 84.0698 267.82 83.6598C267.82 83.2498 267.48 82.9098 267.07 82.9098ZM270.82 84.4098C271.23 84.4098 271.57 84.0698 271.57 83.6598C271.57 83.2498 271.23 82.9098 270.82 82.9098C270.41 82.9098 270.07 83.2498 270.07 83.6598C270.07 84.0698 270.41 84.4098 270.82 84.4098Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_223_28185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299 8.54C298.78 8.51 298.55 8.5 298.32 8.5H12.18C9.05 8.5 6.5 10.94 6.5 13.94V120H7.54V13.94C7.54 11.49 9.62 9.5 12.18 9.5H298.31C298.54 9.5 298.77 9.53 298.99 9.57V8.55L299 8.54Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.16 25.7202H99.19C103 25.7202 106.1 28.8202 106.1 32.6302V54.8302C106.1 58.6402 103 61.7402 99.19 61.7402H41.16C37.35 61.7402 34.25 58.6402 34.25 54.8302V32.6302C34.25 28.8202 37.35 25.7202 41.16 25.7202Z",
    fill: "url(#paint1_linear_223_28185)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.13 25.7202H184.16C187.97 25.7202 191.07 28.8202 191.07 32.6302V54.8302C191.07 58.6402 187.97 61.7402 184.16 61.7402H126.13C122.32 61.7402 119.22 58.6402 119.22 54.8302V32.6302C119.22 28.8202 122.32 25.7202 126.13 25.7202Z",
    fill: "url(#paint2_linear_223_28185)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M211.11 25.7202H269.14C272.95 25.7202 276.05 28.8202 276.05 32.6302V54.8302C276.05 58.6402 272.95 61.7402 269.14 61.7402H211.11C207.3 61.7402 204.2 58.6402 204.2 54.8302V32.6302C204.2 28.8202 207.3 25.7202 211.11 25.7202Z",
    fill: "url(#paint3_linear_223_28185)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.28 53.5802C156.3 53.5802 155.53 52.2002 156.56 50.5102L165.75 35.5502C166.79 33.8602 168.48 33.8602 169.52 35.5502L178.71 50.5102C179.75 52.2002 178.98 53.5802 176.99 53.5802H158.27H158.28Z",
    fill: "url(#paint4_linear_223_28185)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.1599 34.2598H77.0299C75.0417 34.2598 73.4299 35.8715 73.4299 37.8598V49.9898C73.4299 51.978 75.0417 53.5898 77.0299 53.5898H89.1599C91.1482 53.5898 92.7599 51.978 92.7599 49.9898V37.8598C92.7599 35.8715 91.1482 34.2598 89.1599 34.2598Z",
    fill: "url(#paint5_linear_223_28185)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M244.51 44.5002C244.51 50.9902 249.78 56.2602 256.27 56.2602C262.76 56.2602 268.03 50.9902 268.03 44.5002C268.03 38.0102 262.77 32.7402 256.27 32.7402C249.77 32.7402 244.51 38.0102 244.51 44.5002Z",
    fill: "url(#paint6_linear_223_28185)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.21 73.1598C47.21 75.8298 45.04 77.9898 42.37 77.9898C39.7 77.9898 37.53 75.8198 37.53 73.1598C37.53 70.4998 39.7 68.3198 42.37 68.3198C45.04 68.3198 47.21 70.4798 47.21 73.1598Z",
    fill: "url(#paint7_linear_223_28185)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M132.52 73.1598C132.52 75.8298 130.36 77.9898 127.69 77.9898C125.02 77.9898 122.85 75.8198 122.85 73.1598C122.85 70.4998 125.02 68.3198 127.69 68.3198C130.36 68.3198 132.52 70.4798 132.52 73.1598Z",
    fill: "url(#paint8_linear_223_28185)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M103.33 75.9199H55.8899C54.3599 75.9199 53.1299 74.6799 53.1299 73.1599C53.1299 71.6399 54.3699 70.3999 55.8899 70.3999H103.33C104.86 70.3999 106.09 71.6399 106.09 73.1599C106.09 74.6799 104.85 75.9199 103.33 75.9199Z",
    fill: "url(#paint9_linear_223_28185)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.32 88.1101H40.97C40.41 88.1101 39.96 87.4901 39.96 86.7301C39.96 85.9701 40.41 85.3501 40.97 85.3501H88.32C88.88 85.3501 89.33 85.9701 89.33 86.7301C89.33 87.4901 88.88 88.1101 88.32 88.1101Z",
    fill: "url(#paint10_linear_223_28185)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.16 97.4001H39.35C38.59 97.4001 37.97 96.7801 37.97 96.0201C37.97 95.2601 38.59 94.6401 39.35 94.6401H104.17C104.93 94.6401 105.55 95.2601 105.55 96.0201C105.55 96.7801 104.93 97.4001 104.17 97.4001H104.16Z",
    fill: "url(#paint11_linear_223_28185)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M187.65 75.9199H140.21C138.68 75.9199 137.45 74.6799 137.45 73.1599C137.45 71.6399 138.69 70.3999 140.21 70.3999H187.65C189.18 70.3999 190.41 71.6399 190.41 73.1599C190.41 74.6799 189.17 75.9199 187.65 75.9199Z",
    fill: "url(#paint12_linear_223_28185)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M172.92 88.1101H125.57C125.01 88.1101 124.56 87.4901 124.56 86.7301C124.56 85.9701 125.01 85.3501 125.57 85.3501H172.92C173.48 85.3501 173.93 85.9701 173.93 86.7301C173.93 87.4901 173.48 88.1101 172.92 88.1101Z",
    fill: "url(#paint13_linear_223_28185)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M188.49 97.4001H123.67C122.91 97.4001 122.29 96.7801 122.29 96.0201C122.29 95.2601 122.91 94.6401 123.67 94.6401H188.49C189.25 94.6401 189.87 95.2601 189.87 96.0201C189.87 96.7801 189.25 97.4001 188.49 97.4001Z",
    fill: "url(#paint14_linear_223_28185)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M272.86 75.9199H225.42C223.89 75.9199 222.66 74.6799 222.66 73.1599C222.66 71.6399 223.9 70.3999 225.42 70.3999H272.86C274.39 70.3999 275.62 71.6399 275.62 73.1599C275.62 74.6799 274.38 75.9199 272.86 75.9199Z",
    fill: "url(#paint15_linear_223_28185)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M258.16 87.1101H210.81C210.25 87.1101 209.8 86.4901 209.8 85.7301C209.8 84.9701 210.25 84.3501 210.81 84.3501H258.16C258.72 84.3501 259.17 84.9701 259.17 85.7301C259.17 86.4901 258.72 87.1101 258.16 87.1101Z",
    fill: "url(#paint16_linear_223_28185)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M273.7 97.4001H208.88C208.12 97.4001 207.5 96.7801 207.5 96.0201C207.5 95.2601 208.12 94.6401 208.88 94.6401H273.7C274.46 94.6401 275.08 95.2601 275.08 96.0201C275.08 96.7801 274.46 97.4001 273.7 97.4001Z",
    fill: "url(#paint17_linear_223_28185)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M217.34 72.9499C217.34 75.6199 215.18 77.7799 212.51 77.7799C209.84 77.7799 207.67 75.6099 207.67 72.9499C207.67 70.2899 209.84 68.1099 212.51 68.1099C215.18 68.1099 217.34 70.2699 217.34 72.9499Z",
    fill: "url(#paint18_linear_223_28185)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M94.5 84.9399C94.5 81.6299 97.19 78.9399 100.5 78.9399C103.81 78.9399 106.5 81.6299 106.5 84.9399C106.5 88.2499 103.81 90.9399 100.5 90.9399C97.19 90.9399 94.5 88.2499 94.5 84.9399ZM100.51 86.7199C99.4 86.7199 98.35 86.5599 97.42 86.2699C97.13 86.1799 96.85 86.4299 96.97 86.7099C97.55 88.0999 98.92 89.0699 100.51 89.0699C102.1 89.0699 103.47 88.0999 104.05 86.7099C104.17 86.4299 103.89 86.1799 103.6 86.2699C102.67 86.5499 101.62 86.7199 100.51 86.7199ZM98.63 81.9399C98.22 81.9399 97.88 82.6099 97.88 83.4399C97.88 84.2699 98.22 84.9399 98.63 84.9399C99.04 84.9399 99.38 84.2699 99.38 83.4399C99.38 82.6099 99.04 81.9399 98.63 81.9399ZM102.38 84.9399C102.79 84.9399 103.13 84.2699 103.13 83.4399C103.13 82.6099 102.79 81.9399 102.38 81.9399C101.97 81.9399 101.63 82.6099 101.63 83.4399C101.63 84.2699 101.97 84.9399 102.38 84.9399Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_223_28185",
    x: 4.5,
    y: 6.5,
    width: 296.5,
    height: 115.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_223_28185"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_223_28185",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_223_28185",
    x1: -1,
    y1: 60,
    x2: 299,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#525FAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_223_28185",
    x1: 34.25,
    y1: 43.7302,
    x2: 106.1,
    y2: 43.7302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_223_28185",
    x1: 119.22,
    y1: 0.000213505,
    x2: 191.07,
    y2: 0.000213505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_223_28185",
    x1: 204.2,
    y1: 0.000214147,
    x2: 276.04,
    y2: 0.000214147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_223_28185",
    x1: 156.1,
    y1: 43.9302,
    x2: 179.18,
    y2: 43.9302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_223_28185",
    x1: 73.4199,
    y1: 43.9298,
    x2: 92.7599,
    y2: 43.9298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_223_28185",
    x1: 244.51,
    y1: 44.5002,
    x2: 268.03,
    y2: 44.5002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_223_28185",
    x1: 37.54,
    y1: 73.1598,
    x2: 47.21,
    y2: 73.1598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_223_28185",
    x1: 122.85,
    y1: 73.1598,
    x2: 132.52,
    y2: 73.1598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_223_28185",
    x1: 53.1199,
    y1: 73.1599,
    x2: 106.09,
    y2: 73.1599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_223_28185",
    x1: 39.96,
    y1: 86.7301,
    x2: 89.33,
    y2: 86.7301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_223_28185",
    x1: 37.96,
    y1: 96.0201,
    x2: 105.55,
    y2: 96.0201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_223_28185",
    x1: 137.45,
    y1: 73.1599,
    x2: 190.42,
    y2: 73.1599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_223_28185",
    x1: 124.56,
    y1: 86.7301,
    x2: 173.93,
    y2: 86.7301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_223_28185",
    x1: 122.29,
    y1: 96.0201,
    x2: 189.87,
    y2: 96.0201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_223_28185",
    x1: 222.65,
    y1: 73.1599,
    x2: 275.62,
    y2: 73.1599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_223_28185",
    x1: 209.8,
    y1: 85.7301,
    x2: 259.17,
    y2: 85.7301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_223_28185",
    x1: 207.5,
    y1: 96.0201,
    x2: 275.08,
    y2: 96.0201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_223_28185",
    x1: 207.66,
    y1: 72.9399,
    x2: 217.34,
    y2: 72.9399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailed);
export default __webpack_public_path__ + "static/media/Detailed.75376e41.svg";
export { ForwardRef as ReactComponent };